import React from 'react';

export const Footer = () => {
  return (
    <footer className='mt-4 text-gray-200 ' style={{ backgroundColor: '#333' }}>
      <div className='flex flex-row justify-between md:justify-around'>
        <div className='flex flex-col m-4'>
          <a
            href='https://5spicekitchen.carry-out.com/order.asp'
            target='_blank'
            rel='noreferrer'
            className='text-sm font-light text-white '
          >
            Order Online
          </a>
          <a
            href='https://cdn.flow.page/images/17fa13a5-4223-406b-8674-dbb7d71e8ed4-pdf?m=1630784338'
            className='text-sm font-light text-white '
          >
            Food Menu
          </a>
          <a
            href='https://cdn.flow.page/images/8297c7a6-632c-47e5-a415-3e45452b6fed-pdf?m=1630782770'
            className='text-sm font-light text-white '
          >
            Drink Menu
          </a>
          <a
            href='https://cdn.flow.page/images/9f30823c-1d80-480d-bb99-8580cd407296-pdf?m=1630784333'
            className='text-sm font-light text-white '
          >
            Lunch Specials
          </a>
          <a href='/' className='text-sm font-light text-white '>
            Gift Cards
          </a>
          <a href='#contactus' className='text-sm font-light text-white '>
            Contact Us
          </a>
          <a href='#about' className='text-sm font-light text-white '>
            About Us
          </a>
          <a href='#news' className='text-sm font-light text-white '>
            News
          </a>
        </div>
        <div className='flex flex-col'>
          <h4 className='pt-4 mx-3'>Hours</h4>
          <div className='flex justify-between mx-3 text-sm font-light text-white'>
            <p className='mr-3'>Monday:</p>
            <p>11:30AM - 8:30pm</p>
          </div>
          <div className='flex justify-between mx-3 text-sm font-light text-white'>
            <p className='mr-3'>Tuesday:</p>
            <p>Closed</p>
          </div>
          <div className='flex justify-between mx-3 text-sm font-light text-white'>
            <p className='mr-3'>Wed - Thu:</p>
            <p>11:30AM - 8:30pm</p>
          </div>
          <div className='flex justify-between mx-3 text-sm font-light text-white'>
            <p className='mr-3'>Fri - Sat:</p>
            <p>11:30AM - 9:30pm</p>
          </div>
          <div className='flex justify-between mx-3 text-sm font-light text-white'>
            <p className='mr-3'>Sunday:</p>
            <p>12pm - 8:30pm</p>
          </div>
          <div className='mt-4 text-sm text-center'>
            {/* <a src="https://www.google.com/maps/embed?pb=!4v1666194401219!6m8!1m7!1sCAoSLEFGMVFpcFBRdklBZEh2bENaYXREMFJjd2NuaVpRN25KVVZycE9VTWlGczk4!2m2!1d41.96877056214788!2d-88.11134851702992!3f105.4835955107761!4f-7.26099248670144!5f0.7820865974627469">Click here for Virtual Tour</a> */}
            <p>
              <a href='https://goo.gl/maps/Wg1g2D9dBBMMLt6v5'>
                1150 Lake St, <br />
                Roselle, IL 60172
              </a>
            </p>
            <p>
              Phone: <a href='tel:+16305292828'>630-529-2828</a>
            </p>
            {/* <iframe title="virtual tour" src="https://www.google.com/maps/embed?pb=!4v1666194401219!6m8!1m7!1sCAoSLEFGMVFpcFBRdklBZEh2bENaYXREMFJjd2NuaVpRN25KVVZycE9VTWlGczk4!2m2!1d41.96877056214788!2d-88.11134851702992!3f105.4835955107761!4f-7.26099248670144!5f0.7820865974627469" width="600" height="450" style={{"border":0}}allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
          </div>
        </div>
      </div>
      <div className='flex justify-center mt-4'>
        <a
          href='https://www.facebook.com/5spiceusa'
          rel='noreferrer'
          target='_blank'
        >
          <svg
            className='h-6 mx-3 text-white fill-current'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 512 512'
          >
            <path d='M481 258.1c0-124.3-100.8-225-225-225-124.3 0-225 100.7-225 225 0 112.3 82.3 205.4 189.8 222.2V323.1h-57.1v-65h57.1v-49.6c0-56.4 33.5-87.5 85-87.5 24.6 0 50.4 4.4 50.4 4.4v55.4h-28.4c-27.9 0-36.6 17.4-36.6 35.2v42.2h62.4l-10 65h-52.4v157.2C398.7 463.4 481 370.3 481 258.1z' />
          </svg>
        </a>
        <a
          href='https://www.instagram.com/five_spice_kitchen_usa/'
          rel='noreferrer'
          target='_blank'
        >
          <svg
            className='h-6 mx-3 text-white fill-current'
            viewBox='0 0 256 256'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M128 23.064c34.177 0 38.225.13 51.722.745 12.48.57 19.258 2.655 23.769 4.408 5.974 2.322 10.238 5.096 14.717 9.575 4.48 4.479 7.253 8.743 9.575 14.717 1.753 4.511 3.838 11.289 4.408 23.768.615 13.498.745 17.546.745 51.723 0 34.178-.13 38.226-.745 51.723-.57 12.48-2.655 19.257-4.408 23.768-2.322 5.974-5.096 10.239-9.575 14.718-4.479 4.479-8.743 7.253-14.717 9.574-4.511 1.753-11.289 3.839-23.769 4.408-13.495.616-17.543.746-51.722.746-34.18 0-38.228-.13-51.723-.746-12.48-.57-19.257-2.655-23.768-4.408-5.974-2.321-10.239-5.095-14.718-9.574-4.479-4.48-7.253-8.744-9.574-14.718-1.753-4.51-3.839-11.288-4.408-23.768-.616-13.497-.746-17.545-.746-51.723 0-34.177.13-38.225.746-51.722.57-12.48 2.655-19.258 4.408-23.769 2.321-5.974 5.095-10.238 9.574-14.717 4.48-4.48 8.744-7.253 14.718-9.575 4.51-1.753 11.288-3.838 23.768-4.408 13.497-.615 17.545-.745 51.723-.745M128 0C93.237 0 88.878.147 75.226.77c-13.625.622-22.93 2.786-31.071 5.95-8.418 3.271-15.556 7.648-22.672 14.764C14.367 28.6 9.991 35.738 6.72 44.155 3.555 52.297 1.392 61.602.77 75.226.147 88.878 0 93.237 0 128c0 34.763.147 39.122.77 52.774.622 13.625 2.785 22.93 5.95 31.071 3.27 8.417 7.647 15.556 14.763 22.672 7.116 7.116 14.254 11.492 22.672 14.763 8.142 3.165 17.446 5.328 31.07 5.95 13.653.623 18.012.77 52.775.77s39.122-.147 52.774-.77c13.624-.622 22.929-2.785 31.07-5.95 8.418-3.27 15.556-7.647 22.672-14.763 7.116-7.116 11.493-14.254 14.764-22.672 3.164-8.142 5.328-17.446 5.95-31.07.623-13.653.77-18.012.77-52.775s-.147-39.122-.77-52.774c-.622-13.624-2.786-22.929-5.95-31.07-3.271-8.418-7.648-15.556-14.764-22.672C227.4 14.368 220.262 9.99 211.845 6.72c-8.142-3.164-17.447-5.328-31.071-5.95C167.122.147 162.763 0 128 0Zm0 62.27C91.698 62.27 62.27 91.7 62.27 128c0 36.302 29.428 65.73 65.73 65.73 36.301 0 65.73-29.428 65.73-65.73 0-36.301-29.429-65.73-65.73-65.73Zm0 108.397c-23.564 0-42.667-19.103-42.667-42.667S104.436 85.333 128 85.333s42.667 19.103 42.667 42.667-19.103 42.667-42.667 42.667Zm83.686-110.994c0 8.484-6.876 15.36-15.36 15.36-8.483 0-15.36-6.876-15.36-15.36 0-8.483 6.877-15.36 15.36-15.36 8.484 0 15.36 6.877 15.36 15.36Z' />
          </svg>
        </a>
      </div>
      <div className='m-4'>
        <p className='pb-4 mx-3 text-sm font-light text-center text-white'>
          Copyright &copy; 2025 by 5 Spice Kitchen. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
